import PhotoSwipe from 'components/photoswipe';
import PhotoSwipeLightbox from 'components/photoswipe-lightbox';

// if (!customElements.get('photoswipe-gallery')) {
//   customElements.define(
//     'photoswipe-gallery',
//     class BlogLightbox extends HTMLElement {
//       constructor() {
//         super();
//         this.selectors = {
//           gallery: '[id^="Social-gallery-"]',
//           children: 'a[itemprop="contentUrl"]',
//           caption: '.hidden-caption-content',
//         };
//         this.blogLightbox = null;
//         this.blogLightboxCaption = this.dataset.caption === 'true';
//       }

//       connectedCallback() {
//         this.initBlogLightbox();
//       }

//       async initBlogLightbox() {
//         try {
//           const options = {
//             gallery: this.selectors.gallery,
//             children: this.selectors.children,
//             wheelToZoom: true,
//             allowPanToNext: false,
//             pswpModule: () => PhotoSwipe
//           };

//           this.blogLightbox = new PhotoSwipeLightbox(options);
//           if (this.blogLightboxCaption)
//             this.initCaptionContents();
//           this.blogLightbox.init();

//           console.log(this.blogLightbox);
//           console.log(this.blogLightbox.options);
//           console.log(this.blogLightbox.options.children);
//         } catch (error) {
//           console.error('Error initializing PhotoSwipeLightbox:', error);
//         }
//       }

//       initCaptionContents() {
//         this.blogLightbox.on('uiRegister', () => {
//           this.blogLightbox.pswp.ui.registerElement({
//             name: 'custom-caption',
//             order: 9,
//             isButton: false,
//             appendTo: 'root',
//             html: 'Caption text',
//             onInit: (el, pswp) => {
//               this.blogLightbox.pswp.on('change', () => {
//                 const currSlideElement = this.blogLightbox.pswp.currSlide.data.element.parentElement;
//                 let captionHTML = '';
//                 if (currSlideElement) {
//                   const hiddenCaption = currSlideElement.querySelector(this.selectors.caption);
//                   if (hiddenCaption) {
//                     captionHTML = hiddenCaption.innerHTML;
//                   } else {
//                     captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
//                   }
//                 }
//                 el.style.setProperty('--caption-image-width', `${this.blogLightbox.pswp.currSlide.prevDisplayedWidth}px`);
//                 el.innerHTML = captionHTML || '';
//               });
//             }
//           });
//         });
//       }
//     }
//   );
// }

if (!customElements.get('photoswipe-gallery')) {
  customElements.define(
    'photoswipe-gallery',
    class BlogLightbox extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          gallery: '[id^="Social-gallery-"]',
          figure: 'figure',
          children: '[itemprop="contentUrl"]',
          caption: '[data-caption-element]',
          iconClose: '[data-icon-close]',
        };
        this.blogLightbox = null;
        this.blogLightboxOptions = null;
        this.blogLightboxCloseBelow = null;
        this.blogLightboxCloseBelowClass = null;
      }

      connectedCallback() {
        this.initBlogLightbox();
      }

      clickTapAction(e) {
        this.blogLightboxZoom ? 'zoom-or-close' : this.toggleSlide(e);
      }

      toggleSlide(e) {
        const windowHorizontalCenter = window.innerWidth / 2;
        e.x >= windowHorizontalCenter ? this.blogLightbox.pswp.next() : this.blogLightbox.pswp.prev();
      }

      async initBlogLightbox() {
        try {
          this.blogLightboxOptions = {
            gallery: this.selectors.gallery,
            children: this.selectors.children,
            // optionaly adjust viewport
            paddingFn: () => {
              return window.innerWidth < 750 ? this.mobilePadding : this.desktopPadding;
            },
            pswpModule: PhotoSwipe,
            mainClass: this.mainClass,
            easing: 'cubic-bezier(.4,0,.22,1)',
            bgOpacity: 0.2,
            // wheelToZoom: true,
            showHideOpacity: true,
            allowPanToNext: false,
            closeOnVerticalDrag: !this.blogLightboxZoom,
            allowUserZoom: this.blogLightboxZoom,
            imageClickAction: (e) => this.clickTapAction(e),
            tapAction: (e) => this.clickTapAction(e),
            doubleTapAction: this.blogLightboxZoom,
          };

          this.blogLightbox = new PhotoSwipeLightbox(this.blogLightboxOptions);
          this.closeLightboxUI();
          this.initLightboxFilter();
          this.initLightboxPicture();
          this.initLightboxContent();
          this.initLightboxContentResize();
          this.appendLightboxContent();
          this.removeLightboxContent();
          this.blogLightbox.init();
        } catch (error) {
          console.error('Error initializing PhotoSwipeLightbox:', error);
        }
      }

      // register an UI to close the lightbox
      closeLightboxUI() {
        this.blogLightboxCloseBelow = {
          name: 'close-button',
          ariaLabel: 'Close',
          title: 'Close',
          order: 9,
          isButton: true,
          appendTo: 'wrapper',
          html: 'Close',
          onClick: 'close'
        };
        this.blogLightboxCloseBelowClass = `pswp__button--${this.blogLightboxCloseBelow.name}-below`;

        this.blogLightbox.on('uiRegister', () => { this.blogLightbox.pswp.ui.registerElement(this.blogLightboxCloseBelow) });

        this.blogLightbox.addFilter('uiElement', (element, data) => {
          switch (data.name) {
            case 'close':
              element.style.display = 'none';
              break;
            case 'close-button':
              element.innerHTML = this.iconClose && this.iconClose.innerHTML,
              element.classList.add(`${this.blogLightboxCloseBelowClass}`);
              break;
          }
          return element;
        });
      }

      // Parse data-pswp-webp-src attribute
      initLightboxFilter() {
        this.blogLightbox.addFilter('itemData', (itemData, index) => {
          let webpSrc = itemData.element.dataset.pswpWebpSrc;
          if (webpSrc) {
            itemData.webpSrc = webpSrc;
          }
          return itemData;
        });
      }

      // use <picture> instead of <img>
      initLightboxPicture() {
        this.blogLightbox.on('contentLoad', (e) => {
          let { content, isLazy } = e;

          if (content.data.src) {
            // prevent to stop the default behavior
            e.preventDefault();

            // create picture element
            content.pictureElement = document.createElement('picture');

            let sourceWebp;
            if (content.data.webpSrc) {
              sourceWebp = document.createElement('source');
              sourceWebp.srcset = content.data.webpSrc;
              sourceWebp.type = 'image/webp';
            }

            let sourceJpgSmall;
            if (content.data.msrc) {
              sourceJpgSmall = document.createElement('source');
              sourceJpgSmall.srcset = content.data.msrc;
              sourceJpgSmall.type = 'image/jpeg';
              sourceJpgSmall.setAttribute('media', '(max-width: 749px)');
            }

            let sourceJpg = document.createElement('source');
            sourceJpg.srcset = content.data.src;
            sourceJpg.type = 'image/jpeg';

            content.element = document.createElement('img');
            content.element.src = content.data.src;
            content.element.setAttribute('alt', content.data.alt ? content.data.alt : '');
            content.element.className = 'pswp__img';

            if (content.data.webpSrc && sourceWebp) content.pictureElement.appendChild(sourceWebp);
            content.pictureElement.appendChild(sourceJpg);
            if (content.data.msrc && sourceJpgSmall) content.pictureElement.appendChild(sourceJpgSmall);
            content.pictureElement.appendChild(content.element);

            // create caption element
            const pictureElParent = content.data.element.closest(this.selectors.figure);
            const pictureElCaption = pictureElParent.querySelector(this.selectors.caption);
            content.pictureElementCaption = document.createElement('div');
            content.pictureElementCaption.className = 'pswp__img-caption--box';
            content.pictureElementCaption.innerHTML = pictureElCaption ? pictureElCaption.innerHTML : '';

            content.pictureElementWrap = document.createElement('div');
            content.pictureElementWrap.className = 'pswp__img-box';
            content.pictureElementWrap.appendChild(content.pictureElement);
            content.pictureElementCaption.innerHTML && content.pictureElementWrap.appendChild(content.pictureElementCaption);

            content.state = 'loading';

            if (content.element.complete) {
              content.onLoaded();
            } else {
              content.element.onload = () => {
                content.onLoaded();
              };

              content.element.onerror = () => {
                content.onError();
              };
            }
          }
        });
      }

      // update content box size
      updateContentBox(content) {
        content.displayedImageWidth && content.pictureElementWrap.style.setProperty('--pswp-slide-img-width', `${content.displayedImageWidth}px`);
        content.displayedImageHeight && content.pictureElementWrap.style.setProperty('--pswp-slide-img-height', `${content.displayedImageHeight}px`);
      }

      updateContentClosePosition() {
        let closeButtonBelow = document.querySelector(`.${this.mainClass} .${this.blogLightboxCloseBelowClass}`);
        let closeButtonBelowRect = closeButtonBelow?.getBoundingClientRect();
        let contentSpacing = window.innerWidth < 750 ? this.mobilePadding : this.desktopPadding;
        let closeButtonBelowGap = Number(this.dataset.closeButtonBelowGap);

        if(!closeButtonBelow && !closeButtonBelowRect) return;

        closeButtonBelow?.style.setProperty('--pswp-button-close-bottom-top', `${Math.max((contentSpacing.bottom - closeButtonBelowGap), (closeButtonBelowRect.height + closeButtonBelowGap))}px`);
      }

      // photoswipe loaded various elements
      initLightboxContent() {
        this.blogLightbox.on('loadComplete', (e) => {
          const { content, isLazy } = e;
          this.updateContentBox(content);
          this.updateContentClosePosition();
          document.querySelector(`.${this.mainClass}`).setAttribute('data-zoom', this.blogLightboxZoom);
        });
      }

      // photoswipe loaded various elements
      initLightboxContentResize() {
        this.blogLightbox.on('imageSizeChange', (e, width, height, slide) => {
          const { content, isLazy } = e;
          this.updateContentBox(content);
          this.updateContentClosePosition();
        });
      }

      // by default PhotoSwipe appends <img>,
      // but we want to append <picture>
      appendLightboxContent() {
        this.blogLightbox.on('contentAppend', (e) => {
          const { content } = e;
          if (content.pictureElementWrap && !content.pictureElementWrap.parentNode) {
            e.preventDefault();
            this.updateContentBox(content);
            content.slide.container.appendChild(content.pictureElementWrap);
          }
        });
      }

      // for next/prev navigation with <picture>
      // by default PhotoSwipe removes <img>,
      // but we want to remove <picture>
      removeLightboxContent() {
        this.blogLightbox.on('contentRemove', (e) => {
          const { content } = e;
          if (content.pictureElementWrap && content.pictureElementWrap.parentNode) {
            e.preventDefault();
            content.pictureElementWrap.remove();
          }
        });
      }

      get mobilePadding() {
        return {
          top: Number(this.dataset.spaceTopMobile), bottom: Number(this.dataset.spaceBottomMobile), left: 0, right: 0
        };
      }

      get desktopPadding() {
        return {
          top: Number(this.dataset.spaceTop), bottom: Number(this.dataset.spaceBottom), left: 0, right: 0
        };
      }

      get iconClose() {
        let iconClose = this.querySelector(this.selectors.iconClose).cloneNode(true);
        iconClose.style.removeProperty('display');
        return iconClose;
      }

      get blogLightboxZoom() {
        return this.dataset.zoom === 'true';
      }

      get blogLightboxCaption() {
        return this.dataset.caption === 'true';
      }

      get mainClass() {
        return this.dataset.mainClass;
      }
    }
  );
}